import { CalendarLayoutBrowserConstants } from '../constants';
import { setIsAgendaPaneShown } from '../mutators/agendaPaneStateMutators';
import { setIsLeftNavShown } from '../mutators/leftNavStateMutators';
import { setHasUserSetLeftNav } from '../mutators/setHasUserSetLeftNavMutator';
import { setHasUserSetAgendaPane } from '../mutators/setHasUserSetAgendaPaneMutator';
import { getHasUserSetAgendaPane } from '../selectors/getHasUserSetAgendaPane';
import { getHasUserSetLeftNav } from '../selectors/getHasUserSetLeftNav';
import { shouldShowLeftNavAsOverlay } from '../selectors/shouldShowLeftNavAsOverlay';
import {
    updateSelectedViewType,
    SelectedViewTypeSource,
    isBoardViewTypeSelected,
    getSelectedViewType,
} from 'owa-calendar-module-store';
import { LayoutChangeSource, onAvailableWidthBucketChanged } from 'owa-layout';
import { orchestrator } from 'satcheljs';
import { shouldShowAgendaPaneAsOverlay } from '../selectors/shouldShowAgendaPaneAsOverlay';
import { setForcedFlexibleDayView } from '../actions/setForcedFlexibleDayView';
import {
    shouldForceFlexibleDayView,
    shouldRevertFlexibleDayView,
} from '../selectors/forceFlexibleDayViewSelectors';
import { CalendarViewTypeEnum } from 'owa-calendar-view-type';

// TODO: VSO #89735 Audit boundary between surface and board

// Nav and Agenda Pane interaction
orchestrator(onAvailableWidthBucketChanged, () => {
    if (shouldShowLeftNavAsOverlay()) {
        setHasUserSetLeftNav(false);
    }
    if (shouldShowAgendaPaneAsOverlay()) {
        setHasUserSetAgendaPane(false);
    }
});

// left pane visibility
orchestrator(onAvailableWidthBucketChanged, actionMessage => {
    if (
        !getHasUserSetLeftNav() &&
        actionMessage.source != LayoutChangeSource.Init &&
        actionMessage.source != LayoutChangeSource.DateRangeTypeChange
    ) {
        const shouldShowLeftNav = !shouldShowLeftNavAsOverlay() && !isBoardViewTypeSelected();
        setIsLeftNavShown(shouldShowLeftNav);
    }
});

// agenda pane visibility
orchestrator(onAvailableWidthBucketChanged, actionMessage => {
    const { availableWidthBucket, source } = actionMessage;

    if (
        !getHasUserSetAgendaPane() &&
        source != LayoutChangeSource.Init &&
        source != LayoutChangeSource.DateRangeTypeChange
    ) {
        if (getSelectedViewType() === CalendarViewTypeEnum.Monthly) {
            const isAgendaPaneShown =
                availableWidthBucket > CalendarLayoutBrowserConstants.shouldShowAgendaPaneAsOverlay;
            setIsAgendaPaneShown(isAgendaPaneShown);
        }
    }
});

// forced flexible day view
orchestrator(onAvailableWidthBucketChanged, actionMessage => {
    const { source } = actionMessage;
    if (
        source != LayoutChangeSource.CalendarViewTypeChange &&
        source != LayoutChangeSource.DateRangeTypeChange
    ) {
        if (shouldForceFlexibleDayView()) {
            setForcedFlexibleDayView(true);
            updateSelectedViewType(
                CalendarViewTypeEnum.Daily,
                SelectedViewTypeSource.DynamicLayout
            );
        } else if (shouldRevertFlexibleDayView()) {
            setForcedFlexibleDayView(false);
            updateSelectedViewType(
                CalendarViewTypeEnum.Weekly,
                SelectedViewTypeSource.DynamicLayout
            );
        }
    }
});
